module.exports = __webpack_public_path__ + "files/aa1b992039f103b11cabde1d8cc57786.png";